import React, { useState, useEffect } from 'react';
import {
    AppBar,
    Toolbar,
    Box,
    Typography,
    IconButton,
    Button,
    Avatar,
    Drawer,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    Tooltip,
    Badge,
    TextField,
    InputAdornment,
    FormControl,
    Select,
    DialogActions,
    InputLabel
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import userIcon from '../../assets/usericon.svg';
import echobuddyLogo from "../../assets/echobuddy.png";
import { getUserById } from '../../service/user';
import SearchIcon from '@mui/icons-material/Search';
import { getUnreadCount } from '../../service/messaging';
import CloseIcon from '@mui/icons-material/Close';
import { createChatAvailability, listChatAvailabilityByAppName, updateChatAvailabilityStatus } from '../../service/chatAvailabilityService';
import { useAuth } from '../../context/AuthContext';

const Navbar = ({ search, setSearch, onMessagingClick }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isDashboard = location.pathname.startsWith('/dashboard');
    const [mobileOpen, setMobileOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const notificationOpen = Boolean(notificationAnchorEl);
    const [userDetails, setUserDetails] = useState(null);
    const { isAdmin } = useAuth();
    // const [search, setSearch] = useState('');
    const [openChatDialog, setOpenChatDialog] = useState(false);
    const [selectedRoom, setSelectedRoom] = useState('');
    const [chatRooms, setChatRooms] = useState([]);
    const [helpDialogOpen, setHelpDialogOpen] = useState(false);

    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    const [patient, setPatient] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [notifications, setNotifications] = useState([
        // { id: 1, message: 'Your appointment is scheduled for tomorrow', time: '2 hours ago' },
        // { id: 2, message: 'New wellness tips available', time: '1 day ago' },
        // { id: 3, message: 'Your weekly report is ready', time: '3 days ago' },
    ]);
    const [unreadMessages, setUnreadMessages] = useState(0);
    const [userChatStatus, setUserChatStatus] = useState(null);

    const handleNotificationClick = (event) => {
        setNotificationAnchorEl(event.currentTarget);
    };

    const handleNotificationClose = () => {
        setNotificationAnchorEl(null);
    };

    const handleProfile = () => {
        handleClose();
        navigate('/profile');
    };

    const handle247chat = () => {
        handleClose();
        // navigate('/chat');
    };

    // const handleAssessments = () => {
    //     handleClose();
    //     navigate('/assessments');
    // };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAssignChatRoom = async () => {
        if (!selectedRoom) return;

        try {
            await createChatAvailability({
                app_name: "echoshine",
                counsellor_id: user?.id,
                status: "active",
                chat_room: Number(selectedRoom),
                maximum_chat: 1
            });

            window.alert(`Room ${selectedRoom} assigned successfully.`);

            // refresh rooms after assigning
            fetchChatAvailability();

            setOpenChatDialog(false);
            setSelectedRoom("");

        } catch (error) {
            console.error("Failed to assign chat room:", error);

            window.alert("Failed to assign chat room. Please try again.");
        }
    };

    const handleLogout = () => {
        handleClose();                  // close any menus/dialogs
        localStorage.removeItem('user'); // remove user datauser_id
        localStorage.removeItem('user_id'); // remove user data
        localStorage.removeItem('userExpiry'); // remove user data
        localStorage.removeItem('conserve_category'); // remove user data
        localStorage.removeItem('account_type'); // remove user data
        localStorage.removeItem('package_type'); // remove user data
        navigate('/', { replace: true }); // redirect to login and replace history
    };

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                if (storedUser) {
                    const user = JSON.parse(storedUser);
                    const userData = await getUserById(user.id);
                    // API returns { success, doctor: {...} }
                    setUserDetails(userData?.doctor || userData);
                }
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        };

        fetchUserDetails();
    }, []);

    // Fetch unread message count
    useEffect(() => {
        const fetchUnreadCount = async () => {
            if (user?.id) {
                try {
                    const data = await getUnreadCount('doctor', user.id);
                    setUnreadMessages(data.unread_count || 0);
                } catch (error) {
                    console.error('Error fetching unread count:', error);
                }
            }
        };

        fetchUnreadCount();

        // Poll every 10 seconds for new messages
        // const interval = setInterval(fetchUnreadCount, 10000);
        // return () => clearInterval(interval);
    }, [user?.id]);


    // console.log("user.id", user.id)

    const fetchChatAvailability = async () => {
        try {
            const data = await listChatAvailabilityByAppName("echoshine");
            setChatRooms(data);

            // ✅ Check if this user already has a room
            const existingRoom = data.find(
                (room) => room.counsellor_id === user.id
            );

            if (existingRoom) {
                setSelectedRoom(existingRoom.chat_room);
                setUserChatStatus(existingRoom.status); // ✅ store status
            } else {
                setSelectedRoom("");
                setUserChatStatus(null);
            }

        } catch (error) {
            console.error("Failed to fetch chat availability:", error);
        }
    };

    const allRooms = [1, 2, 3, 4];

    // const availableRooms = allRooms.filter((roomNumber) => {
    //     const assignedRoom = chatRooms.find(
    //         (room) => room.chat_room === roomNumber
    //     );

    //     // If room not assigned → show
    //     if (!assignedRoom) return true;

    //     // If assigned to current user → show
    //     if (assignedRoom.counsellor_id === user.id) return true;

    //     // Assigned to someone else → hide
    //     return false;
    // });

    const availableRooms = allRooms.filter((roomNumber) => {
        const assignedRoom = chatRooms.find(
            (room) => room.chat_room === roomNumber
        );

        // If room not assigned → show
        if (!assignedRoom) return true;

        // If room belongs to current user → show
        if (assignedRoom.counsellor_id === user.id) return true;

        // If room is not active → show
        if (assignedRoom.status !== 'active') return true;

        // Room is active and assigned to someone else → hide
        return false;
    });

   

    useEffect(() => {
        fetchChatAvailability();
    }, []);

    const isUserAssignedRoom = chatRooms.some(
        (room) =>
            room.counsellor_id === user.id &&
            room.chat_room === Number(selectedRoom)
    );

    const handleToggleChatStatus = async () => {
        try {
            const newStatus = userChatStatus === "inactive" ? "active" : "inactive";

            await updateChatAvailabilityStatus(user.id, "echoshine", newStatus);

            window.alert(
                newStatus === "active"
                    ? "You are now online successfully."
                    : "You are now offline successfully."
            );

            fetchChatAvailability();
            setOpenChatDialog(false);

        } catch (error) {
            console.error("Failed to update chat status:", error);
            window.alert("Failed to update chat status. Please try again.");
        }
    };

    const drawerContent = (
        <Box sx={{ p: 2, width: 250 }}>

            <Box sx={{ display: 'flex', alignItems: 'center', mt: 7 }}>
                <Tooltip title="Notifications" arrow>
                    <IconButton
                        onClick={handleNotificationClick}
                        sx={{ backgroundColor: '#f1f5f9', mr: 1 }}
                    >
                        <Badge
                            badgeContent={notifications.length}
                            color="error"
                            sx={{
                                '& .MuiBadge-badge': {
                                    fontSize: '0.6rem',
                                    height: 16,
                                    minWidth: 16,
                                    padding: '0 4px',
                                    top: 4,
                                    right: 4
                                }
                            }}
                        >
                            <NotificationsIcon sx={{ color: '#4f46e5', width: 20, height: 20, }} />
                        </Badge>
                    </IconButton>
                </Tooltip>
                <Typography variant="body2" sx={{ fontWeight: 500, cursor: 'pointer' }} onClick={handleNotificationClick}>
                    Notifications
                </Typography>
            </Box>

            <Menu
                anchorEl={notificationAnchorEl}
                open={notificationOpen}
                onClose={handleNotificationClose}
                onClick={handleNotificationClose}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        width: 320,
                        maxWidth: '100%',
                        mt: 1.5,
                        borderRadius: 2,
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)'
                    }
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <div style={{ padding: '12px 16px', borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
                    <span style={{ fontSize: '1rem', fontWeight: 'bold' }}>Notifications</span>
                </div>
                <div style={{ maxHeight: 350, overflowY: 'auto' }}>
                    {notifications.length > 0 ? (
                        notifications.map((notification) => (
                            <div
                                key={notification.id}
                                style={{
                                    padding: '12px 16px',
                                    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                    }
                                }}
                            >
                                <div style={{ fontSize: '0.875rem', marginBottom: '4px' }}>
                                    {notification.message}
                                </div>
                                <div style={{ fontSize: '0.75rem', color: 'rgba(0, 0, 0, 0.6)' }}>
                                    {notification.time}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{
                            padding: '24px 16px',
                            textAlign: 'center',
                            color: 'rgba(0, 0, 0, 0.6)'
                        }}>
                            No new notifications
                        </div>
                    )}
                </div>
            </Menu>

            {/* <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                <IconButton onClick={handleClick} disableRipple>
                    <Avatar
                        src={userIcon}
                        sx={{
                            width: 33,
                            height: 33,
                            bgcolor: '#E4E8FF'
                        }}
                    />
                </IconButton>

                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Hello {user?.name?.replace(/\b\w/g, (char) => char.toUpperCase()) || "Guest"}
                </Typography>
            </Box> */}
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <IconButton onClick={handleClick} disableRipple>
                    <Avatar
                        src={
                            userDetails?.id ? `/api/v1/doctors/${userDetails.id}/avatar` :
                            userDetails?.gender?.toLowerCase() === 'male' ? '/man.png' :
                                userDetails?.gender?.toLowerCase() === 'female' ? '/woman.png' :
                                    '/user.png'
                        }
                        imgProps={{ referrerPolicy: "no-referrer" }}
                        sx={{
                            width: 33,
                            height: 33,
                            bgcolor: userDetails?.gender?.toLowerCase() === 'male'
                                ? '#E4E8FF'
                                : userDetails?.gender?.toLowerCase() === 'female'
                                    ? '#FFE4E8'
                                    : '#E8E8E8'
                        }}
                    />
                </IconButton>

                <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                    Hello {userDetails?.name?.replace(/\b\w/g, (char) => char.toUpperCase()) || "Guest"}
                </Typography>
            </Box>
        </Box>
    );

    return (
        <>
            <AppBar
                position="sticky"
                color="transparent"
                elevation={0}
                sx={{

                    top: 0,
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    px: { xs: 1, sm: 2 },
                    backgroundColor: '#ffff',
                    height: { xs: 56, sm: 64, md: 70 }, // responsive heights
                    minHeight: { xs: 56, sm: 64, md: 70 },
                    background: 'linear-gradient(135deg, #ffff 0%, #ffff 100%)',
                }}
            >
                <Toolbar
                    disableGutters
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                    }}
                >
                    {/* LEFT */}
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                        <Link
                            to="/home"
                            style={{
                                textDecoration: 'none',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Box
                                component="img"
                                src="/diginxthlt-logo.svg"
                                alt="Diginxthlt Logo"
                                sx={{
                                    height: { xs: 35, sm: 40, md: 60 },
                                    width: { xs: 35, sm: 40, md: 60 },
                                    mr: 0.5,
                                    ml: -0.5,

                                }}
                            />

                            <Box>
                                <Typography sx={{ fontSize: '1.4rem', fontWeight: 700, lineHeight: 1.2 }}>
                                    Provider Portal
                                </Typography>
                                <Typography variant="caption" sx={{ lineHeight: 1 }}>
                                    Connect. Heal. Rise.
                                </Typography>
                            </Box>

                        </Link>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            display: { xs: 'none', sm: 'flex' },
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                        }}
                    >
                        {/* Messaging Icon */}
                        <Tooltip title="Messaging" arrow>
                            <IconButton
                                onClick={() => navigate('/messaging')}
                                sx={{
                                    ml: 2,
                                    backgroundColor: isUserAssignedRoom ? '#22c55e20' : '#f1f5f9',
                                    '&:hover': {
                                        backgroundColor: isUserAssignedRoom ? '#22c55e30' : '#e2e8f0'
                                    }
                                }}
                                disableRipple
                            >
                                <Badge
                                    badgeContent={unreadMessages}
                                    color="error"
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            fontSize: '0.6rem',
                                            height: 16,
                                            minWidth: 16,
                                            padding: '0 4px',
                                            top: 4,
                                            right: 4
                                        }
                                    }}
                                >
                                    <ChatBubbleOutlineIcon
                                        sx={{
                                            color: isUserAssignedRoom ? '#22c55e' : '#0a66c2',
                                            width: 20,
                                            height: 20
                                        }}
                                    />
                                </Badge>
                            </IconButton>
                        </Tooltip>

                        <>
                            {/* desktop view */}
                            <IconButton onClick={handleClick} sx={{ ml: 2 }} disableRipple>


                                <Avatar src={
                                    userDetails?.id ? `/api/v1/doctors/${userDetails.id}/avatar` :
                                    userDetails?.gender?.toLowerCase() === 'male' ? '/man.png' :
                                        userDetails?.gender?.toLowerCase() === 'female' ? '/woman.png' :
                                            '/user.png'
                                }
                                    imgProps={{ referrerPolicy: "no-referrer" }}
                                    sx={{
                                        width: 33,
                                        height: 33,
                                        bgcolor: userDetails?.gender?.toLowerCase() === 'male'
                                            ? '#E4E8FF'
                                            : userDetails?.gender?.toLowerCase() === 'female'
                                                ? '#FFE4E8'
                                                : '#E8E8E8'
                                    }}
                                />
                            </IconButton>

                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                PaperProps={{
                                    sx: {
                                        minWidth: 120,
                                        width: '220px',
                                    }
                                }}
                            >
                                {/* Admin-only Counsellor menu item */}
                                {isAdmin && (
                                    <MenuItem onClick={() => {
                                        handleClose();
                                        navigate('/counsellors');
                                    }}>
                                        Counsellor
                                    </MenuItem>
                                )}
                                 <MenuItem onClick={() => {
                                        handleClose();
                                        navigate('/all-appointments');
                                    }}>
                                        Appointments
                                    </MenuItem>

                                {/* <MenuItem onClick={handleAssessments}>
                                    Assessments
                                </MenuItem> */}

                                <MenuItem onClick={() => setOpenChatDialog(true)}>
                                    24/7 Chat
                                </MenuItem>

                                <MenuItem onClick={() => {
                                    handleClose();
                                    navigate('/my-availability');
                                }}>
                                    My Availability
                                </MenuItem>

                                <MenuItem onClick={handleProfile}>
                                    Profile
                                </MenuItem>


                                {patient && (
                                    <MenuItem>
                                        {patient.full_name} — {patient.dr_name}
                                    </MenuItem>
                                )}

                                <MenuItem
                                    onClick={() => {
                                        handleClose();
                                        setHelpDialogOpen(true);
                                    }}
                                >
                                    Help
                                </MenuItem>

                                <MenuItem onClick={handleLogout}>
                                    Logout
                                </MenuItem>
                            </Menu>

                            <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                                Hello {user?.name?.replace(/\b\w/g, (char) => char.toUpperCase()) || "Guest"}
                            </Typography>
                        </>
                    </Box>

                    {/* Hamburger Icon (Only on Mobile) */}
                    <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
                        <IconButton onClick={handleDrawerToggle}>
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
            >
                {drawerContent}
            </Drawer>


            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Patient Profile</DialogTitle>
                <DialogContent dividers>
                    {patient ? (
                        <>
                            <Typography><strong>Full Name:</strong> {patient.full_name}</Typography>
                            <Typography><strong>Age:</strong> {patient.age}</Typography>
                            <Typography><strong>Gender:</strong> {patient.gender}</Typography>
                            <Typography><strong>Marital Status:</strong> {patient.marital_status}</Typography>
                            <Typography><strong>Consultation Type:</strong> {patient.consultation_type}</Typography>
                            <Typography><strong>Consulting For:</strong> {patient.consulting_type}</Typography>
                            <Typography><strong>Doctor:</strong> {patient.dr_name}</Typography>
                            <Typography><strong>Date:</strong> {new Date(patient.date).toLocaleDateString()}</Typography>
                            <Typography><strong>Time:</strong> {patient.time}</Typography>
                            <Typography><strong>Created At:</strong> {new Date(patient.created_at).toLocaleString()}</Typography>
                        </>
                    ) : (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 150 }}>
                            <CircularProgress />
                        </Box>
                    )}
                    <Button variant="contained" sx={{ mt: 2 }} onClick={() => setDialogOpen(false)}>
                        Close
                    </Button>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openChatDialog}
                onClose={() => setOpenChatDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: '0 20px 60px rgba(0,0,0,0.08)',
                        paddingTop: 1,
                    },
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        fontWeight: 600,
                        fontSize: 18,
                        px: 3,
                        pb: 1,
                    }}
                >
                    Chat Room

                    <IconButton
                        onClick={() => setOpenChatDialog(false)}
                        size="small"
                        sx={{
                            backgroundColor: '#F5F7FA',
                            '&:hover': { backgroundColor: '#E9EEF5' },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                {/* Content */}
                <DialogContent sx={{ px: 3, pt: 1, pb: 2, }}>
                    <FormControl fullWidth size="medium" sx={{ mt: 1 }}>
                        {isUserAssignedRoom ? (
                            // ✅ Read-only TextField when already assigned
                            <TextField
                                label="Assigned Room"
                                value={`Room ${selectedRoom}`}
                                InputProps={{
                                    readOnly: true,
                                }}
                                sx={{ borderRadius: 2 }}
                            />
                        ) : (
                            // ✅ Normal dropdown when not assigned
                            <>
                                <InputLabel>Select Room</InputLabel>
                                <Select
                                    value={selectedRoom}
                                    onChange={(e) => setSelectedRoom(e.target.value)}
                                    label="Select Room"
                                    sx={{ borderRadius: 2 }}
                                >
                                    {availableRooms.length > 0 ? (
                                        availableRooms.map((room) => (
                                            <MenuItem key={room} value={room}>
                                                Room {room}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem disabled>
                                            No Rooms Available
                                        </MenuItem>
                                    )}
                                </Select>
                            </>
                        )}
                    </FormControl>
                </DialogContent>

                {/* Actions */}
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    {isUserAssignedRoom ? (
                        <Button
                            variant={userChatStatus === "inactive" ? "contained" : "outlined"}
                            fullWidth
                            onClick={handleToggleChatStatus}
                            sx={{
                                height: 44,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: 14,
                                ...(userChatStatus === "inactive"
                                    ? {
                                        background: "linear-gradient(135deg, #1AAE7A, #117D58)",
                                        boxShadow: "0 8px 20px rgba(26,174,122,0.25)",
                                        "&:hover": {
                                            background: "linear-gradient(135deg, #179e70, #0f6d4d)",
                                        },
                                    }
                                    : {
                                        borderColor: "#ef4444",
                                        color: "#ef4444",
                                        "&:hover": {
                                            borderColor: "#dc2626",
                                            backgroundColor: "#fee2e2",
                                        },
                                    }),
                            }}
                        >
                            {userChatStatus === "inactive" ? "Go Online" : "Go Offline"}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            fullWidth
                            disabled={!selectedRoom}
                            sx={{
                                height: 44,
                                borderRadius: 2,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 14,
                                background: 'linear-gradient(135deg, #1AAE7A, #117D58)',
                                boxShadow: '0 8px 20px rgba(26,174,122,0.25)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #179e70, #0f6d4d)',
                                },
                            }}
                            onClick={handleAssignChatRoom}
                        >
                            Assign
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
<Dialog
    open={helpDialogOpen}
    onClose={() => setHelpDialogOpen(false)}
    maxWidth="xs"
    fullWidth
>
    <DialogTitle>
        Help Documents
    </DialogTitle>

    <DialogContent dividers>
        <Button
            fullWidth
            variant="outlined"
            sx={{ mb: 2 }}
            onClick={() =>
                window.open("/ProviderPortal-UserManual.pdf", "_blank")
            }
        >
            Provider Portal User Manual
        </Button>

        <Button
            fullWidth
            variant="outlined"
            onClick={() =>
                window.open("/Ready_Reckoner.pdf", "_blank")
            }
        >
            Ready Reckoner
        </Button>
    </DialogContent>

    <DialogActions>
        <Button onClick={() => setHelpDialogOpen(false)}>
            Close
        </Button>
    </DialogActions>
</Dialog>
        </>
    );
};

export default Navbar;
